/**
 * The display name of a register.
 *
 * The catalogue the API returns is derived from the schema, so its labels are English —
 * they are the names of tables, not user-interface strings. The eight register names are a
 * closed set and worth translating; the ~150 column labels inside them are the client's own
 * terminology and will be translated when the client supplies the Arabic terms, not guessed
 * at here. Until then a column header stays in English, which is honest, rather than being
 * machine-translated into something a reviewer would have to decode.
 *
 * The API label is the fallback, so a register added after this ships still has a name.
 */
import type { TFunction } from 'i18next'

export function registerLabel(t: TFunction, slug: string, fallback: string): string {
  return t(`registers.${slug}`, { defaultValue: fallback })
}
